import { inject, Provider, signal } from '@angular/core';
import { NavItemType, provideNavItems } from 'navigation-data';
import { PRODUCTS_ROUTE_PATH } from 'products-data';

import { defaultProductPromotionsFeatureConfig, ProductsFeatureConfig } from './ProductsFeatureConfig';
import { provideProductsFeatureRoutes } from './products-feature.routes';

import { provideStandardProductType, provideWireProductType } from 'products-ui';
import { MainMenuLocalization } from './localization/MainMenuLocalization';

export function provideProductsFeature(config?: Partial<ProductsFeatureConfig>): Provider {
  const useConfig = { ...defaultProductPromotionsFeatureConfig, ...config };
  return [
    provideProductsFeatureRoutes(config?.routes),
    provideNavItems(
      {
        type: NavItemType.RouteLink,
        id: 'app.main-menu/products/browse',
        label: signal(MainMenuLocalization.BrowseProductsLabel),
        icon: signal('inventory_2'),
        command: () => signal(['/', inject(PRODUCTS_ROUTE_PATH), 'browse']),
        linkOptions: () => signal({ exact: false }),
        priority: signal(102),
        heading: signal(MainMenuLocalization.FindProductsHeading),
      },
      {
        type: NavItemType.RouteLink,
        id: 'app.main-menu/products/search',
        label: signal(MainMenuLocalization.AdvancedSearchLabel),
        icon: signal('search'),
        command: () => signal(['/', inject(PRODUCTS_ROUTE_PATH), 'search']),
        linkOptions: () => signal({ exact: false }),
        priority: signal(101),
        heading: signal(MainMenuLocalization.FindProductsHeading),
      },
      {
        type: NavItemType.RouteLink,
        id: 'app.main-menu/products/quick-order',
        label: signal(MainMenuLocalization.QuickOrderLabel),
        icon: signal('action_key'),
        command: () => signal(['/', inject(PRODUCTS_ROUTE_PATH), 'quick-order']),
        linkOptions: () => signal({ exact: false }),
        priority: signal(100),
        heading: signal(MainMenuLocalization.FindProductsHeading),
      },
    ),
    provideStandardProductType(),
    provideWireProductType(),
  ];
}
